// Module
var code = `<section class="reviewers-rubrics-access-help-wrapper" role="status" aria-live><p translate="activity-editor-new_reviewers-rubrics-access-help"></p></section>`;
// Exports
export default code;